import { defineMessages } from 'react-intl';

export const ordersTabsMessages = defineMessages({
  digitalOrdersTabLabel: {
    defaultMessage: 'Digital',
    description: 'Orders Screen | Digital orders tab title',
  },
  digitalOrdersTabA11yLabel: {
    defaultMessage: 'Show digital orders tab',
    description: 'Orders Screen | Digital orders tab a11y label',
  },
  inStoreOrdersTabLabel: {
    defaultMessage: 'In-Store',
    description: 'Orders Screen | In-store orders tab title',
  },
  inStoreOrdersTabA11yLabel: {
    defaultMessage: 'Show in-store orders tab',
    description: 'Orders Screen | In-store orders tab a11y label',
  },
});
